export function makeParentPassword() {
  const n = String(Math.floor(10000 + Math.random() * 90000));
  return `Parent@${n}aA`;
}

export function makeTeacherPassword() {
  const n = String(Math.floor(10000 + Math.random() * 90000));
  return `Teacher@${n}aA`;
}

/** Sets password fields used on add forms (single field). */
export function applyAddPassword(form, password) {
  form.setFieldsValue({ password });
}

/** Sets password fields used on update-password forms (new + confirm). */
export function applyUpdatePassword(form, password) {
  form.setFieldsValue({ newPassword: password, confirmPassword: password });
}

/** @deprecated Prefer applyAddPassword or applyUpdatePassword with makeParentPassword / makeTeacherPassword */
export const generatePassword = (form) => {
  applyAddPassword(form, makeParentPassword());
};

export function generateParentUpdatePassword(form) {
  applyUpdatePassword(form, makeParentPassword());
}

export function generateTeacherUpdatePassword(form) {
  applyUpdatePassword(form, makeTeacherPassword());
}
